import { useContext, useEffect } from "react";
import styled from "styled-components";
import Header from "../../layouts/header/Header";
import { useTranslation } from "react-i18next";
import { ProductContext } from "../../context/ProductContext";
import ProductSlider from "../../components/product/ProductSlider";
import HomeHero from "../../components/hero/HomeHero";
import BannerHorizontal from "../../components/hero/BannerHorizontal";
import Footer from "../footer/Footer";
//import Subscription from "../footer/Subscription";
import ProductSliderHorizontal from "../../components/product/ProductSliderHorizontal";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  //height: 100vh;
`;
const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
const PromoTitle = styled.h2`
  font-size: var(--font-size-xlarge);
  margin: 40px 0 14px 0;
`;
const HomeMain = () => {
  const { t } = useTranslation();
  const {
    products,
    bestSellers,
    newArrivals,
    loadNewArrivals,
    loadProducts,
    loadBestSellers,
    setCategory,
    category,
  } = useContext(ProductContext);

  useEffect(() => {
    if (category) {
      loadProducts();
      setCategory(null);
    } else if (products.length) {
      loadBestSellers();
      loadNewArrivals();
    } else {
      loadProducts();
    }
  }, [products]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [products]);

  return (
    <>
      <Header />
      <Container>
        <HomeHero />
        <Section>
          <PromoTitle>{t("HOME.BEST_SELLERS")}</PromoTitle>
          <ProductSlider products={bestSellers} />

          <BannerHorizontal />

          <PromoTitle>{t("HOME.NEW_ARRIVALS")}</PromoTitle>
          <ProductSliderHorizontal products={newArrivals} />
        </Section>
      </Container>

      <Footer />
    </>
  );
};

export default HomeMain;
